import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles(
  (theme) => ({
    items: {},
    card: {
      border: '1px solid rgba(196, 196, 196, 0.5);',
      borderRadius: '20px',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.01)',
    },
    uuid: {
      overflowWrap: 'anywhere',
    },
    secondColumn: {
      marginTop: theme.spacing(2),
    },
    lastColumn: {
      marginBottom: theme.spacing(4),
    },
    wrap: {
      flexWrap: 'wrap',
    },
    alert: {
      background: '#FFF1F0',
      border: '1px solid #FFA39E',
      boxSizing: 'border-box',
      borderRadius: '2px',
      padding: theme.spacing(0, 1),
    },
    root: {
      marginTop: theme.spacing(3),
      padding: theme.spacing(5, 0),
    },
    amount: {
      paddingTop: theme.spacing(2),
      '&:last-child': {
        paddingBottom: theme.spacing(2),
      },
    },
    divider: {
      marginTop: theme.spacing(1),
    },
    secondaryButton: {
      color: theme.palette.common.azureRadiant,
      border: `1px solid ${theme.palette.common.azureRadiant}`,
      boxSizing: 'border-box',
      borderRadius: '20px',
      '&:hover, &:focus': {
        background: 'rgba(0, 122, 255, 0.1)',
      },
      minWidth: 0,
      marginLeft: theme.spacing(1),
    },
    editButton: {
      height: '30px',
      width: '42px',
    },
    hidden: {
      visibility: 'hidden',
    },
    successMessage: {
      marginTop: theme.spacing(1),
      justifyContent: 'center',
    },
    ref2Message: {
      maxWidth: '40ch',
      cursor: 'default',
      display: '-webkit-box',
      '-webkit-line-clamp': '2',
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      wordBreak: 'break-all',
    },
    [theme.breakpoints.up('lg')]: {
      items: {
        position: 'relative',
        '&:after': {
          content: '""',
          background: 'rgba(196, 196, 196, 0.5)',
          position: 'absolute',
          bottom: 0,
          right: 0,
          height: '100%',
          width: '1px',
        },
      },
    },
  }),
  { name: 'TransactionDetail' }
);

export const CustomTooltip = withStyles({
  tooltip: {
    color: '#4F4F4F',
    backgroundColor: '#FAFAFA',
    boxShadow: '0px 0px 8px 1px #d1cfcfdd;',
  },
})(Tooltip);

export default useStyles;
